// extracted by mini-css-extract-plugin
export default {"title":"AllocationBreadcrumbs_title__9VgWO"};